<template>
    <div v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container" style="position: relative">
            <span>註冊</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div class="login-container">

            <div style="padding: 20px">
                <img src="../assets/img_logo.png" alt="" style="width: 20%" />
            </div>

            <div class="input-container">
                <img src="../assets/img_phone.png" alt="">
                <input v-model="userName" placeholder="請輸入手機號或者郵箱">
            </div>

            <div class="input-container" style="margin-top: 20px">
                <img src="../assets/img_confirm_pwd.png" alt="">
                <input type="password" v-model="password" placeholder="請輸入密碼">
            </div>

            <div class="input-container" style="margin-top: 20px">
                <img src="../assets/img_confirm_pwd.png" alt="">
                <input type="password" v-model="confirmPassword" placeholder="請再次輸入密碼">
            </div>

            <button @click="register">註冊</button>

        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "RegisterVue",
    data() {
        return {
            isRequest: false,
            userName: "",
            password: "",
            confirmPassword: "",
            fromVueName: "",
            chapterId: "",
            bookId: "",
            bookName: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            if (this.fromVueName === "ChapterDetailVue") {
                this.$router.push({
                    path: "ChapterDetailVue",
                    query: {
                        bookId: this.bookId,
                        chapterId: this.chapterId,
                    },
                });
            } else {
                this.$router.go(-1);
            }
        },

        //註冊
        register: function () {
            if (this.userName === null || this.userName === "") {
                alert("請輸入手機號或者郵箱");
                return;
            }
            if (this.password === null || this.password === "") {
                alert("請輸入密碼");
                return;
            }
            if (this.confirmPassword === null || this.confirmPassword === "") {
                alert("請再次輸入密碼");
                return;
            }
            if (this.password !== this.confirmPassword) {
                alert("兩次密碼不壹致");
                return;
            }
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "reg");
            params.append("mobile", this.userName);
            params.append("pwd", this.password);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.login();
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //登錄
        login: function () {
            localStorage.setItem("userName", this.userName);
            localStorage.setItem("pwd", this.password);
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "login");
            params.append("mobile", this.userName);
            params.append("pwd", this.password);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.loginData = res.data.data;
                    localStorage.setItem("userId", this.loginData.id);
                    localStorage.setItem("token", this.loginData.token);
                    if (this.fromVueName === "ChapterDetailVue") {
                        this.$router.push({
                            path: "ChapterDetailVue",
                            query: {
                                bookId: this.bookId,
                                chapterId: this.chapterId,
                                bookName: this.bookName,
                            },
                        });
                    } else {
                        this.$router.push({
                            path: "MineVue",
                        });
                    }
                } else {
                    alert(res.data.msg);
                }
            });
        },
    },
    created() {
        this.fromVueName = this.$route.query.vueName;
        this.bookId = this.$route.query.bookId;
        this.bookName = this.$route.query.bookName;
        this.chapterId = this.$route.query.chapterId;
    },
};
</script>

<style scoped>
.login-container {
    max-width: 480px;
    height: 100%;
    margin: 0 auto;
}

.input-container {
}

.input-container input {
    width: 70%;
    height: 40px;
    padding-left: 10px;
    outline: none;
    border: 1px solid gray;
    color: black;
    border-radius: 5px;
    font-size: 14px;
}

.login-container button {
    width: 70%;
    height: 35px;
    background: #f2c510;
    border: 1px solid #f2c510;
    border-radius: 5px;
    outline: none;
    color: black;
    font-size: 16px;
    margin-top: 20px;
}

.login-container button:active {
    background-color: #fc9504;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterVue.vue